const ARS_FORMATTER = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' });

/** `basePriceCents` is integer cents; e.g. `150000` → "$ 1.500,00". */
export function formatBasePrice(basePriceCents: number): string {
  return ARS_FORMATTER.format(basePriceCents / 100);
}
